import type { SvgIconProps } from '@mui/material'
import { SvgIcon } from '@mui/material'
import type React from 'react'

/** Left-nav glyph for the Messages section — a chat bubble in `currentColor`. */
const MenuMessageIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon name="MenuMessageIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2.5A2.5 2.5 0 0 0 1.5 5v11A2.5 2.5 0 0 0 4 18.5h2.5v3.1a.9.9 0 0 0 1.46.7L12.9 18.5H20a2.5 2.5 0 0 0 2.5-2.5V5A2.5 2.5 0 0 0 20 2.5H4Zm2.25 6.25A1.25 1.25 0 1 1 8.75 8.75 1.25 1.25 0 0 1 6.25 8.75Zm5.75 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm5.75-1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export default MenuMessageIcon
